import Drawer from 'components/drawer/Drawer';
import NativeSelect from 'components/native-select/NativeSelect';
import { bindEmitterMethod } from 'helpers/bind';
import store from 'store';
export default class WebstoreSwitcher extends Drawer {
    allLanguages = [];
    constructor(el, options) {
        super(el, options);
        this.name = 'webstore-switcher';
        this.params = {
            desktop: {
                axis: 'X',
                direction: 'reversed'
            },
            mobile: {
                axis: 'Y',
                direction: 'reversed'
            }
        };
    }
    initialized() {
        super.initialized();
        if (this.el.dataset.splash === 'true')
            store.drawer.set('webstore-switcher');
        this.allLanguages = Array.from(this.modules.nativeSelect[1].el.children[0].children);
    }
    getModulesMap() {
        return {
            nativeSelect: ['.native-select', NativeSelect]
        };
    }
    bindEvents(add) {
        super.bindEvents(add);
        const emitterMethod = bindEmitterMethod(add);
        this.refs.stay.addEventListener('click', this.onStayClick);
        this.modules.nativeSelect[0][emitterMethod]('change', this.onSelectChange);
        const p = this.parent;
        p.pageManager[emitterMethod]('load:end', this.onAfterRouteChange);
    }
    onAfterRouteChange = () => {
        this.refs.form.action = window.location.pathname;
    };
    onSelectChange = (option) => {
        const languages = option.dataset.languages.split(',');
        const availableLanguages = this.allLanguages.filter((language) => languages.includes(language.value));
        this.allLanguages.forEach((language) => { language.hidden = !languages.includes(language.value); });
        availableLanguages[0].selected = true;
    };
    onStayClick = (e) => {
        if (this.el.dataset.splash === 'false')
            e.preventDefault();
        store.drawer.set(null);
        store.persistantOverlay.set(false);
    };
}
